import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed} from 'vue';
import DateHelper from "~/ts/library/Date";


const __default__ = {
    name: "CoreUiChatHistoryMessageTimeValue"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    message: {},
    showSeconds: { type: Boolean },
    utc: { type: Boolean }
  },
  setup(__props: any) {

let props = __props;

let time = computed(() => {
    let date = new DateHelper(props.message.dateTime, props.utc);
    let result = date.toMysqlFormatTime();
    if (!props.showSeconds) {
        result = result.substring(0, 5);
    }
    return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(_unref(time)), 1))
}
}

})